































import { Component, Vue, Watch } from 'vue-property-decorator';
import { TableStripe } from '@/mixins/tableStripe';
import publishObjectPath from '@/util/configRegistry';
import { performanceServer } from '@/api/installServer';

@Component({
  components: {},
  mixins: [TableStripe],
})
export default class ChoiceCheckDialog extends Vue {
  private visible = false;
  private idList: any = '';
  formData: any = {
    remark: '',
  };

  userRules: any = {
    remark: [{ required: true, trigger: 'blur', message: '请填写备注' }], // 备注
  };

  private async showAddDialog(pid: any) {
    this.formData = {
      remark: '',
    };
    this.idList = pid;
    this.visible = true;
  }

  /**
   * @description 点击返回按钮 关闭弹窗
   */
  returnDialog() {
    this.visible = false;
  }

  /**
   * @description 点击保存按钮
   */
  saveDialog() {
    const formComponent: any = this.$refs.form;
    formComponent.validate((valid: any) => {
      if (!valid) {
        return;
      }
      this.deletePerformance();
    });
  }

  // 删除考试点击事件
  deletePerformance() {
    performanceServer
      .deletePerformanceList(this.idList, this.formData.remark)
      .then((res: any) => {
        this.$message.success('删除成功!');
        this.returnDialog(); // 重新渲染表格数据
        this.$emit('refreshData');
      })
      .catch(() => {
        this.$message.error('删除失败，请稍后重试！');
      });
  }
}
